import moment from "moment";

import { Guid } from "@/Common/Models/Guid";
import { ServiceComboTargetClientele } from "@/Common/Models/Services/Enums/ServiceComboTargetClientele";

class PredefinedAppointment {
    public Id: Guid;
    public Version: number;
    public Duration: number;
    public Start: Date;
    public End: Date;
    public Name: string;
    public RoomId: Guid;
    public ServiceDefinitionId: Guid;
    public EmployeeId: Guid;
    public ResourceId: Guid;
    public SiteId: Guid;
    public IsOnlineBookingAllowed: boolean;
    public TargetedClient: ServiceComboTargetClientele;

    public static FromJsonResponseObject(responseObject: any): PredefinedAppointment {
        var appt: PredefinedAppointment = responseObject;
        if (appt.Start) {
            appt.Start = moment(appt.Start).toDate();
        }
        return appt;
    }
}

export { PredefinedAppointment };
